import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { renderStatusColor } from "utils/statusColor";
import { TimeFormat, DateFullFormat } from "utils/dateFormat";
import CurrencyFormat from "utils/currencyFormat";
import Maybe from "components/__new/common/Maybe";
import FormDrawer from "components/__new/common/form-drawer";
import ModalDetailsContent from "components/__new/common/ModalDetailsContent";


export const TransactionDetails = (props) => {
    const { transaction, isOpen, setIsOpen } = props;

    return (
        <FormDrawer isOpen={isOpen} setIsOpen={setIsOpen}>
            <div>
                <div className="p-6">
                    <div className="flex justify-between">
                        <div className="font-medium text-2xl">
                            Transaction Details
                        </div>
                        <div onClick={() => setIsOpen(false)} className="modal-close group">
                            <FontAwesomeIcon icon="times" className="customizeSVG group-hover:text-white m-auto" />
                        </div>
                    </div>
                    <div className="text-fade text-sm">
                        {transaction.description}
                    </div>
                </div>

                <div className="w-full h-px my-2 bg-gray-200"></div>

                <div className="p-6 flex flex-row flex-wrap">
                    {/*
                    <div className="w-full mb-6 font-semibold text-sm">
                        Legal Information
                    </div>
                     */}
                    <ModalDetailsContent label="Transaction Date" value={DateFullFormat(transaction.createdAt) + " at " + TimeFormat(transaction.createdAt)} />
                    <ModalDetailsContent label="Transaction Type" value={<div className="capitalize">{transaction.type}</div>} />
                    <ModalDetailsContent label="Source Type" value={<div className="capitalize">{transaction.sourceType?.replaceAll("-", " ")}</div>} />
                    <ModalDetailsContent label="Target" value={<div className="capitalize">{transaction.target}</div>} />
                    <ModalDetailsContent label="Previous Balance" value={transaction.previousBalance ? CurrencyFormat(transaction.previousBalance / 100) : "-"} />
                    <ModalDetailsContent label="Reference" value={transaction.reference} />
                    <ModalDetailsContent label="Amount" value={transaction.amount ? CurrencyFormat(transaction.amount / 100) : "-"} />
                    <ModalDetailsContent label="Transaction Reference" value={transaction.transactionRef} />
                    <ModalDetailsContent label="Current Balance" value={transaction.newBalance ? CurrencyFormat(transaction.newBalance / 100) : "-"} />
                    <ModalDetailsContent label="Approval Status" value={<div className={"label " + renderStatusColor(transaction.status)}>{transaction.status}</div>} />
                    {transaction?.sourceType !== "charge" && <ModalDetailsContent label="Transaction Description" value={transaction?.description || "N/A"} />}

                    <Maybe condition={transaction?.sourceType === "bill-payment" && transaction?.providerResponse?.units?.length}>
                        <ModalDetailsContent label="Recharge token" value={transaction?.providerResponse?.token} />
                        <ModalDetailsContent label="Recharge amount" value={transaction?.providerResponse?.amount ? CurrencyFormat(transaction?.providerResponse?.amount) : ""} />
                        <ModalDetailsContent label="Meter number" value={transaction?.providerResponse?.account} />
                        <ModalDetailsContent label="Units" value={transaction?.providerResponse?.units} />
                        <ModalDetailsContent label="Name" value={transaction?.providerResponse?.name} />
                        <ModalDetailsContent label="Address" value={transaction?.providerResponse?.address} />
                    </Maybe>
                    
                    
                    <Maybe condition={transaction?.sourceType === "bank-transfer" && transaction?.recipient?.bankName?.length}>
                        <ModalDetailsContent label="Recipient Bank" value={transaction?.recipient?.bankName} />
                        <ModalDetailsContent label="Recipient Account Number" value={transaction?.recipient?.accountNumber} />
                        <ModalDetailsContent label="Recipient Account Name" value={transaction?.recipient?.accountName} />
                    </Maybe>
                </div>
            </div>
        </FormDrawer>
    )
}


export default TransactionDetails;